import styles from './TariffList.module.css';

export function TariffList() {
  return (
    <ul className={styles.tariffList} aria-label="Mogelijke tarieven">
      <li className={styles.tariffRow}>
        <span className={styles.tariffHeaderRow}>
          <span className={styles.tariffLabel}>Nieuw teleconsult</span>
          <strong>€ 32</strong>
        </span>
        <span className={styles.tariffDesc}>Voor dit probleem hebt u de laatste 30 dagen geen consultatie gehad.</span>
      </li>
      <li className={styles.tariffRow}>
        <span className={styles.tariffHeaderRow}>
          <span className={styles.tariffLabel}>Enkel voorschrift</span>
          <strong>€ 5</strong>
        </span>
        <span className={styles.tariffDesc}>U hebt een voorschrift nodig voor een probleem dat reeds wordt opgevolgd bij uw dermatoloog.</span>
      </li>
      <li className={styles.tariffRow}>
        <span className={styles.tariffHeaderRow}>
          <span className={styles.tariffLabel}>Opvolgconsult</span>
          <strong>€ 0</strong>
        </span>
        <span className={styles.tariffDesc}>U hebt voor dit probleem in de laatste 30 dagen al een fysieke of digitale consultatie gehad bij uw dermatoloog.</span>
      </li>
    </ul>
  );
}
